function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import PropTypes from "prop-types";
import React, { Component } from "react";
import * as ScanditSDK from "scandit-sdk";
import Picker from "./picker-wrapper";

var Scanner = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Scanner, _Component);

  function Scanner() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "picker", new Picker());

    _defineProperty(_assertThisInitialized(_this), "scannerContainerRef", React.createRef());

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this.configureLibrary().then(function () {
        return _this.initializePicker();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      if (_this.picker) {
        _this.picker.destroy();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (prevProps) {
      _this.updatePicker(prevProps);
    });

    _defineProperty(_assertThisInitialized(_this), "configureLibrary", function () {
      return ScanditSDK.configure(_this.props.licenseKey, {
        engineLocation: _this.props.engineLocation,
        preloadBlurryRecognition: _this.props.preloadBlurryRecognition,
        preloadEngine: _this.props.preloadEngine
      });
    });

    _defineProperty(_assertThisInitialized(_this), "initializePicker", function () {
      _this.picker.initialize(_this.scannerContainerRef.current, _this.props);
    });

    _defineProperty(_assertThisInitialized(_this), "updatePicker", function (prevProps) {
      _this.picker != null && _this.picker.update(prevProps, _this.props);
    });

    return _this;
  }

  var _proto = Scanner.prototype;

  _proto.render = function render() {
    return /*#__PURE__*/React.createElement("div", {
      ref: this.scannerContainerRef
    });
  };

  return Scanner;
}(Component);

Scanner.propTypes = process.env.NODE_ENV !== "production" ? {
  licenseKey: PropTypes.string.isRequired,
  engineLocation: PropTypes.string.isRequired,
  preloadBlurryRecognition: PropTypes.bool,
  preloadEngine: PropTypes.bool,
  accessCamera: PropTypes.bool,
  camera: PropTypes.object,
  cameraSettings: PropTypes.object,
  cameraType: PropTypes.any,
  enableCameraSwitcher: PropTypes.bool,
  enablePinchToZoom: PropTypes.bool,
  enableTapToFocus: PropTypes.bool,
  enableTorchToggle: PropTypes.bool,
  guiStyle: PropTypes.any,
  laserArea: PropTypes.any,
  mirrorImage: PropTypes.bool,
  paused: PropTypes.bool,
  playSoundOnScan: PropTypes.bool,
  scanSettings: PropTypes.object,
  singleImageModeSettings: PropTypes.object,
  targetScanningFPS: PropTypes.number,
  vibrateOnScan: PropTypes.bool,
  videoFit: PropTypes.any,
  visible: PropTypes.bool,
  viewfinderArea: PropTypes.any,
  zoom: PropTypes.number,
  onReady: PropTypes.func,
  onScan: PropTypes.func,
  onScanError: PropTypes.func,
  onProcessFrame: PropTypes.func,
  onSubmitFrame: PropTypes.func
} : {};
export default Scanner;